const state = {
  books: []
};

const getters = {
  getBooks(state) {
    return state.books;
  }
};

const mutations = {
  getBook(state, book) {
    state.books = book;
  }
};

const actions = {

};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/book.js